import { Component, Vue } from 'vue-property-decorator'
import SessionStorageService from '@/common/SessionStorageService'
import CommonConstants from '@/common/CommonConstants'
import CommonUtil from '@/common/utils/CommonUtil'

@Component({
  name: 'LOGINRDRCT'
  })
export default class LOGINRDRCTController extends Vue {
  /**
   * 画面要素描画後処理
   */
  created() {
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {
    const redirectRiv = Number(this.$route?.query?.redirectRiv)
    const errorCode = String(this.$route?.query?.errorCode)
    if (redirectRiv === 4) {
      CommonUtil.gotoLogoutJISTSite()
      const messageError = []
      if (errorCode !== 'undefined') {
        messageError.push({
          code: errorCode,
          message: CommonUtil.getMessage(errorCode, []),
          url: ''
        })
        SessionStorageService.setItem(
          CommonConstants.MESSAGE_ERROR,
          JSON.stringify(messageError)
        )

        for (const e of CommonConstants.LIST_ERROR_CODE_MAPPING_SCREEN) {
          if (e.errorCode.includes(errorCode)) {
            SessionStorageService.setItem(
              CommonConstants.MESSAGE_ERROR,
              JSON.stringify(messageError)
            )
            this.$router.push(e.screenId)
            return
          }
        }
      }

      this.$router.push({ name: 'caag1010', params: { isShowMessage: '1' } })
      return
    }

    if (redirectRiv === 3) {
      this.$router.replace({ name: 'caag1120' })
    }
  }
}
